<template>
  <div v-cloak>
    <transition appear appear-active-class="fade-enter-active" name="fade">
      <div v-if="apiLoaded || errorText">
        <div v-if="apiLoaded" class="wrap">

          <h1>Оперативный мониторинг
<!--            <CznUserInfo :change-callback="behalUserChangeCallback"></CznUserInfo>-->
          </h1>

            <department-info
                @depObj="onDepObj"
            ></department-info>
          <div class="custom-up-modern-wave">
            <ModernizationWave :count="department?.region?.modernizationWave" />
          </div>

          <h2>Направления</h2>


          <div v-for="direction in config.directions" :key="direction.id" class="list monitoring">

            <div class="list-item-wrap">

              <v-expansion-panels>
                <v-expansion-panel
                    :key="direction.id"
                >
                  <v-expansion-panel-header>

                    <div class="list-item">
                      <a class="list-item-name">
                        <button class="toggleSwitch">
                          <svg class="closed" fill="none" height="24" viewBox="0 0 24 24" width="24"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="M12 14.5L17 9.5L7 9.5L12 14.5Z" fill="#1551D0"/>
                          </svg>
                          <svg class="opened" fill="none" height="24" viewBox="0 0 24 24" width="24"
                               xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5 12L9.5 7L9.5 17L14.5 12Z" fill="#1551D0"/>
                          </svg>
                        </button>
                        <span>{{ direction.name }}</span>
                      </a>
                      <v-progress-circular
                          :rotate="-90"
                          :size="50"
                          :value="getDirectionReadiness(direction.id)"
                          :width="6"
                          color="#0033A0"
                      >
                        {{ getDirectionReadiness(direction.id) }}
                      </v-progress-circular>
                      <div class="edit"
                           @click.stop="$router.push('/monitoring/edit/'+direction.id + (configId ? '/' + configId : '') + '/' + department.id)">
                        <v-icon class="icon-item icon-note-edit-outline"></v-icon>
                      </div>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <table>
                      <thead>
                      <tr>
                        <th>Мероприятие</th>
                        <th>Пройденный этап</th>
                        <th>Дата завершения этапа</th>
                        <th>Сумма</th>
                        <th>Предстоящий этап</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="action in direction.actions" :key="direction.id + '.' + action.id">
                        <td>{{ action.name }}</td>
                        <td>{{ (t = getAccomplishedStage(direction.id, action.id)) ? t.name : '&mdash;' }}</td>
                        <td> {{
                            (t = getLastAccomplishedValue(direction.id, action.id)) ? formatDate(t.endDate) : '&mdash;'
                          }}
                        </td>
                        <td>{{
                            (t = getLastAccomplishedValue(direction.id, action.id)) ? t.price : '&mdash;'
                          }}</td>
                        <td>{{ (t = getNextStage(direction.id, action.id)) ? t.name : '&mdash;' }}</td>
                      </tr>
                      <tr>
                        <td colspan="5">
                          <v-checkbox
                              label="Готовность к предоставлению материалов для итогового рейтинга"
                              :readonly="!editable"
                              :input-value="getReadiness(direction.id)"
                              @change="submitReadiness(direction.id, $event)"
                          ></v-checkbox>
                        </td>
                      </tr>
                      </tbody>
                    </table>


                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>

            </div>
          </div>
        </div>
        <div v-if="errorText!=null" class="error" style="position: fixed;bottom: 0">
          Ошибка: {{ errorText }}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
  </div>
</template>

<style lang="scss">
@import "../styles/main.scss";
</style>


<style lang="scss">
@import "../styles/main.scss";
</style>

<style lang="scss" scoped>
</style>

<script>
// import CznUserInfo from "./elements/CznUserInfo";
import departmentInfo from "@/components/elements/DepartmentInfo";
import ModernizationWave from "@/components/elements/ModernizationWave";

export default {
  name: "MonitoringInfo",
  props: {},
  components: {
    // CznUserInfo
    departmentInfo,
    ModernizationWave
  },
  data() {
    return {
      configId: null,
      config: null,
      userRegion: null,
      department: null,
      values: [],
      readinessArray: [],
      apiLoaded: false,
      editable: false,
      errorText: null
    };
  },
  methods: {
    onDepObj(dep) {
      this.department = dep;
      this.initializeData();
      this.$nextTick(() => {
        console.log('department:', this.department);
      });
    },
    setUserInitialParams() {
      if (this.$user.role === 'ROLE_CZN_TERRITORIAL' || this.$user.role === 'ROLE_CZN_MANAGER') {
        this.userRegion = this.$user.region;
        this.department = this.$user.department;
      } else if (this.$user.role === 'ROLE_REGIONAL_AGENCY') {
        this.userRegion = this.$user.region;
        // Находим регион пользователя в $cznDepartmentsByRegionList для того, чтобы из него получить список ЦЗН региона
        let region = this.$cznDepartmentsByRegionList.filter((region) => {return region.name === this.userRegion.name})
        this.department = region[0].departments[0];
      } else { //для админов и ВНИИ Труда
        this.userRegion = this.$cznDepartmentsByRegionList[0];
        this.department = this.userRegion.departments[0];
      }
    },

    async loadConfig() {
      let req
      if (this.configId == null) {
        req = await this.$getApi("/monitoring/getActiveConfig")
      } else {
        req = await this.$getApi("/monitoring/getConfig", {id: this.configId})
      }
      if (req.ok) {
        this.config = req.payload
        this.config.directions = JSON.parse(this.config.directionsJson)
        // console.log('this.config', this.config)
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    async loadStageValues() {
      let req = await this.$getApi("/monitoring/getStageValues",
          {userName: this.department.id, configId: this.config.id})
      if (req.ok) {
        this.values = req.payload
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    async loadReadinessArray(){
      let req = await this.$getApi("/monitoring/getDirectionStatuses",
          {userName: this.department.id, configId: this.config.id})
      if (req.ok) {
        this.readinessArray = req.payload
        // console.log(this.readinessArray)
      } else {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
    },

    getDirectionReadiness(directionId) {
      return Math.round(this.getDirectionValuesPresent(directionId) / this.getDirectionStagesCount(directionId) * 100)
    },

    getDirectionStagesCount(directionId) {
      let count = 0
      for (let direction of this.config.directions) {
        if (direction.id === directionId) {
          for (let action of direction.actions) {
            count += action.stages.length
          }
        }
      }
      return count
    },

    getDirectionValuesPresent(directionId) {
      let count = 0
      for (let stageValue of this.values) {
        if (stageValue.directionId === directionId)
          count++
      }
      return count
    },

    getLastAccomplishedValue(directionId, actionId) {
      let maxStageId
      let lastValue
      for (let value of this.values) {
        if (value.directionId === directionId && value.actionId === actionId && (maxStageId == null || value.stageId > maxStageId)) {
          maxStageId = value.stageId
          lastValue = value
        }
      }
      return lastValue
    },

    getAccomplishedStage(directionId, actionId) {
      let lastValue = this.getLastAccomplishedValue(directionId, actionId)
      if (lastValue == null)
        return null
      return this.getStage(directionId, actionId, lastValue.stageId)
    },

    getNextStage(directionId, actionId) {
      let curStage = this.getAccomplishedStage(directionId, actionId)
      if (curStage == null)
        return this.getStage(directionId, actionId, 100)
      else
        return this.getStage(directionId, actionId, curStage.id + 100)
    },

    getDirection(directionId) {
      for (let direction of this.config.directions) {
        if (directionId === direction.id)
          return direction
      }
      return null
    },

    getAction(directionId, actionId) {
      let direction = this.getDirection(directionId)
      if (direction == null)
        return null
      for (let action of direction.actions) {
        if (action.id === actionId)
          return action
      }
      return null
    },

    getStage(directionId, actionId, stageId) {
      let action = this.getAction(directionId, actionId)
      if (action == null)
        return null
      for (let stage of action.stages) {
        if (stage.id === stageId)
          return stage
      }
      return null
    },

    getReadiness(directionId){
      for(let status of this.readinessArray){
        if(status.directionId === directionId)
          return true
      }
      return false
    },

    formatDate(date) {
      if (date == null) {
        return ''
      }
      let mdate = new Date(date)
      let options = {timeZone: 'Europe/Moscow', year: 'numeric', month: 'numeric', day: 'numeric'}
      return mdate.toLocaleDateString('ru-RU', options)
    },

    async submitReadiness(directionId, val) {
      if (this.apiFreeze) {
        return
      }
      this.apiFreeze = true
      this.editable = false
      let req = await this.$postFormDataApi("/monitoring/saveDirectionStatus", {
        userName: this.department.id, //this.$user.username
        configId: this.config.id,
        directionId: directionId,
        ready: val
      })
      if (!req.ok) {
        this.errorText = "Ошибка подключения к серверу или обработки запроса: " + req.error
      }
      this.editable = true
      this.apiFreeze = false
    },

    async initializeData() {
      await this.loadConfig();
      let prms1 = this.loadStageValues()
      let prms2 = this.loadReadinessArray()
      await prms1
      await prms2
      this.editable = (this.config.active) &&
                      (this.$user.role==='ROLE_CZN_MANAGER' ||
                       this.$user.role==='ROLE_CZN_TERRITORIAL' ||
                       this.$user.role==='ROLE_REGIONAL_AGENCY');
    },
  },

  async beforeMount() {
    this.setUserInitialParams();
    this.configId = this.$route.params.configId;
    await this.initializeData();
    this.apiLoaded = true;
  }
};
</script>
<style>
.custom-up-modern-wave{
  position: relative;
  bottom:40px;
}

</style>
